// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * The frame a source's own mark is drawn in.
 *
 * Geometry is copied from \`CatalogKindIcon\`'s size classes rather than
 * invented, because the two swap for each other: a source with an icon and one
 * without must occupy identical space or the card grid goes ragged the moment
 * one portal ships a logo.
 */
.lk88IXStWV6jOaXWTmoa {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  overflow: hidden;
  /* Neutral, not the source tint. These are the portals' own marks and they
     carry their own colours; a brand-adjacent magenta panel behind the City of
     Chicago's seal would misrepresent both. The glyph fallback keeps the tint,
     because that one IS ours. A hairline keeps a white-on-white mark from
     dissolving into the card. */
  background: var(--curio-card-bg);
  box-shadow: inset 0 0 0 1px var(--curio-border);
  padding: 3px;
  box-sizing: border-box;
  line-height: 1;
}

.KVbGVRWMG7gweNwJDIeH {
  width: 100%;
  height: 100%;
  /* \`contain\`, not \`cover\`: a portal's mark is a logo, and cropping one to
     fill a square is how you cut the top off somebody's wordmark. */
  object-fit: contain;
  display: block;
}

.sh2M8cL8ntT5fT0_4hfv {
  width: 22px;
  height: 22px;
  border-radius: 6px;
}

._VftR2k1MUuvvsaP19H4 {
  width: 36px;
  height: 36px;
  border-radius: 8px;
}

.TPX7gzS9Hm9My6SVtiWj {
  width: 48px;
  height: 48px;
  border-radius: 10px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/discovery/DiscoverySourceIcon.module.css"],"names":[],"mappings":"AAAA;;;;;;;EAOE;AACF;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,gBAAgB;EAChB;;;;gCAI8B;EAC9B,gCAAgC;EAChC,+CAA+C;EAC/C,YAAY;EACZ,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ;oEACkE;EAClE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB","sourcesContent":["/*\n * The frame a source's own mark is drawn in.\n *\n * Geometry is copied from `CatalogKindIcon`'s size classes rather than\n * invented, because the two swap for each other: a source with an icon and one\n * without must occupy identical space or the card grid goes ragged the moment\n * one portal ships a logo.\n */\n.frame {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  overflow: hidden;\n  /* Neutral, not the source tint. These are the portals' own marks and they\n     carry their own colours; a brand-adjacent magenta panel behind the City of\n     Chicago's seal would misrepresent both. The glyph fallback keeps the tint,\n     because that one IS ours. A hairline keeps a white-on-white mark from\n     dissolving into the card. */\n  background: var(--curio-card-bg);\n  box-shadow: inset 0 0 0 1px var(--curio-border);\n  padding: 3px;\n  box-sizing: border-box;\n  line-height: 1;\n}\n\n.image {\n  width: 100%;\n  height: 100%;\n  /* `contain`, not `cover`: a portal's mark is a logo, and cropping one to\n     fill a square is how you cut the top off somebody's wordmark. */\n  object-fit: contain;\n  display: block;\n}\n\n.size_sm {\n  width: 22px;\n  height: 22px;\n  border-radius: 6px;\n}\n\n.size_md {\n  width: 36px;\n  height: 36px;\n  border-radius: 8px;\n}\n\n.size_lg {\n  width: 48px;\n  height: 48px;\n  border-radius: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"frame": `lk88IXStWV6jOaXWTmoa`,
	"image": `KVbGVRWMG7gweNwJDIeH`,
	"size_sm": `sh2M8cL8ntT5fT0_4hfv`,
	"size_md": `_VftR2k1MUuvvsaP19H4`,
	"size_lg": `TPX7gzS9Hm9My6SVtiWj`
};
export default ___CSS_LOADER_EXPORT___;
